import { Component, Input, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { VhQueryAutoWeb, VhAlgorithm } from 'vhautowebdb';
import { Subscription } from 'rxjs';
import { isPlatformBrowser } from '@angular/common';
import { PLATFORM_ID, Inject, Injectable } from '@angular/core';

@Component({
  selector: 'atw-frame-news-group-admin',
  templateUrl: './frame-news-group-admin.component.html',
  styleUrls: ['./frame-news-group-admin.component.scss'],
})
export class AtwFrameNewsGroupAdmin implements OnInit {
  @Input() data;
  public newsShow: any = [];
  public listCategory: any[];
  public pageCurrent: number = 1;
  public totalPages: number = 1;
  public limit: number = 10; // giới hạn sản phẩm trên 1 trang
  public listNumbersPage: number[] = [];
  public listChooseItem: any = [10, 20, 50, 100];
  public searchNameProduct: string = '';
  public pageShowChoose: any = [1, 2, 3]; /** Số trang hiển thị = */
  public pageGoto: number = 1; /** Trang người dùng chuyển tới hiển thị = */
  public subscribe: Subscription;
  public isASC: boolean = true; // true. A->Z, false. Z->A
  public tableHeight: string; // biến dùng để chứa chiều cao của bảng dữ liệu
  public categories: Array<any> = [];
  constructor(
    private routeActiva: ActivatedRoute,
    private router: Router,
    public vhQueryAutoWeb: VhQueryAutoWeb,
    public vhAlgorithm: VhAlgorithm,
    @Inject(PLATFORM_ID) private platformId: Object,
  ) { }

  ngOnInit(): void {
    if (isPlatformBrowser(this.platformId))
      this.subscribe = this.routeActiva.queryParams.subscribe((routeParam) => {
        if (routeParam.page) {
          this.pageCurrent = parseInt(routeParam.page);
          this.onSearchNews(this.pageCurrent);
          this.pageShowChoose = this.pageShowChoose.map((num, index) => {
            return (num = this.pageCurrent + index - 1);
          });
        } else this.getNews(this.pageCurrent);
      });
  }

  trackByFn(index: number, item: any) {
    return item.id; // hoặc sử dụng một thuộc tính duy nhất khác của item
  }

  ngOnDestroy(): void {
    this.subscribe?.unsubscribe();
  }

  getNews(pageCurrent?) {
    this.vhQueryAutoWeb
      .getNewss_byFields({ type: { $eq: 1 } }, {}, {}, this.limit, pageCurrent)
      .then(
        (res: any) => {

          this.listCategory = res.data;
          this.newsShow = this.listCategory;
          this.totalPages = res.totalpages;
        },
        (err) => console.error(err)
      );
  }

  counter(i: number) {
    return new Array(i);
  }

  changeItemOnPage(value) {
    // this.limit = Number(value);
    // this.pageCurrent = 1;
    // let stringUrl =
    //   this.location.path().split('/').slice(0, -1).join('/') +
    //   '/' +
    //   this.pageCurrent;
    // if (this.searchNameProduct == "") this.router.navigateByUrl(stringUrl);
    // else this.onSearchNews(this.pageCurrent)
  }

  /** Chuyển trang -----------------
   *
   * @param value
   */
  transferFn(value: number): void {
    this.pageCurrent = Number(value);
    this.pageGoto = Number(value);
    if (this.searchNameProduct == '')
      this.router.navigate([], {
        queryParams: { page: this.pageCurrent },
      });
    else this.onSearchNews(this.pageCurrent);
    // Thay đổi giá trị trang cho người dùng chọn
    if (this.pageCurrent < this.totalPages && this.pageCurrent > 1) {
      if (
        this.pageShowChoose[this.pageShowChoose.length - 1] == this.pageCurrent
      )
        this.pageShowChoose = this.pageShowChoose.map((num) => num + 1);
      else if (this.pageShowChoose[0] == this.pageCurrent)
        this.pageShowChoose = this.pageShowChoose.map((num) => num - 1);
    }
  }
  /** Chuyển trang đến trang trước
   *
   */
  gotoPreviousPage() {
    if (this.pageCurrent > 1) {
      this.transferFn(this.pageCurrent - 1);
    } else if (this.pageCurrent == 1) {
      this.transferFn(this.totalPages);
    }
  }

  /** Chuyển trang đến trang sau
   *
   */
  gotoNextPage() {
    if (this.pageCurrent < this.totalPages) {
      this.transferFn(this.pageCurrent + 1);
    } else if ((this.pageCurrent = this.totalPages)) {
      this.transferFn(1);
    }
  }

  /** Hàm thực hiện cập nhật trạng thái sản phẩm (show_web)
   *
   * @param id
   * @param event
   */
  updateShowWeb(id, value) {
    let data = {
      [`${this.data._id}_hidden`]: value,
    };
    this.vhQueryAutoWeb.updateNews(id, data);
  }

  public checkKey(event) {
    if (event.keyCode == 13) {
      this.onSearchNews(1);
    }
  }

  onSearchNews(pageCurrent) {
    if (this.searchNameProduct != '') {
      this.vhQueryAutoWeb
        .searchList(
          'newss',
          ['title'],
          this.searchNameProduct, { name: 1 },

        )
        .then((result: any) => {

          if (result.vcode === 0) {
            this.newsShow = result.data.filter((item) => item.type == 1);
          }
        });
    } else this.getNews(pageCurrent);
  }

  /**Sắp xếp sản phẩm theo thứ tự
   *
   */
  softProducts() {
    if (this.isASC) {
      this.newsShow = this.vhAlgorithm.sortVietnamesebyASC(
        this.newsShow,
        'name'
      );
      this.isASC = true;
    } else {
      this.newsShow = this.vhAlgorithm.sortVietnamesebyDESC(
        this.newsShow,
        'name'
      );
    }
    this.isASC = !this.isASC;
  }
}
